import { VideoPlayer } from "../../../../modules/content/components/VideoPlayer/VideoPlayer";
import { GroundCommonContent } from "../../../../modules/content/components/GroundCommonContent/GroundCommonContent";
import { GroundSection } from "../../../../modules/content/components/GroundSection/GroundSection";
import type { IVideoBlockProps } from "./VideoBlock.props";

export const VideoBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  parentClass,
  spacing,
  videoBanner,
  videoSource,
  vimeoVideo,
  youtubeVideo,
}: IVideoBlockProps) => {
  const selectedVideo = videoSource === "youtube" ? youtubeVideo : vimeoVideo;
  if (!selectedVideo) return null;
  return (
    <GroundSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-8 md:gap-12">
        <GroundCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <VideoPlayer
          banner={videoBanner}
          source={videoSource}
          vimeoVideo={vimeoVideo}
          youtubeVideo={youtubeVideo}
        />
      </div>
    </GroundSection>
  );
};

VideoBlock.displayName = "Block::VideoBlock";
